<template>
<div class="video full-size page" v-bind:class="classObject">
   <video autoplay loop defaultMuted v-on:click="play"
          src='/static/newfilm.mp4'
          class='full-size' />
   <router-link class='close-link bold'
                :to="{ name: 'Home'}"><img class='arrow'
           src='/static/arrow.png' /> Back</router-link>
</div>

</template>

<script>
import Transition from '@/mixins/transition';

export default {

    name: 'Video',

    mixins: [

        Transition
    ],

    data()  {
        return {
            msg: 'Tickets'
        }
    },

    components: {
    },

    methods: {
      play(e){
        var video = e.currentTarget;
        video.addEventListener('click',function(){ video.play(); },false);
      }
    },

    computed: {
        // classObject: () => ({
        //   'isMobile': this.$store.getters['app/getMobile']
        // })

        classObject() {
          return {
            'isMobile': this.$store.getters['app/getMobile']  
          }
        }
    }
}

</script>

<!-- isMobile() {
    return this.$store.getters['app/getMobile']
} -->

<style scoped="" lang="scss">

.video{
  background: #e9e9e9;
}

video {
   position: absolute;
   top: 50%;
   left: 50%;
   width: auto;
   height: auto;
   min-width: 100%;
   min-height: 100%;
   transform: translate(-50%, -50%);
}

.isMobile{
  video{
    width: 100%;
  }
}

.close-link {
   position: absolute;
   right: 32px;
   top: 2rem;
   color: #140d0f;
   font-size: 22px;
   @media (min-width: 992px) {
      font-size: 2vw;
      right: 4vw;
   }
   .arrow {
      height: .55em;
      transition: transform 0.4s;
      transform: rotate(180deg);
   }
   &:hover {
      .arrow {
         transform: translateX(-.3em) rotate(180deg);
      }
   }
}
</style>



// WEBPACK FOOTER //
// Video.vue?723b3ac0